import React, { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Accordion,
    AccordionItem,
    Collapse,
} from "reactstrap";
import classnames from 'classnames';

interface CollapseFilterProps {
    children: ReactNode;
    style?: any
}

const CollapseFilter: React.FC<CollapseFilterProps> = ({
    children,
    style = {},
}) => {
    const { t } = useTranslation();
    const [collapseFilterGroup, setCollapseFilterGroup] = useState<boolean>(true);
    const [collapseFilter, setCollapseFilter] = useState<any>('collapseFilter')
    const AccordionComponent = Accordion as any;
    return (
        <AccordionComponent open={collapseFilter}>
            <AccordionItem className="filter-border-lg-0 border-0">
                <h2 className="accordion-header" >
                    <button
                        className={`${classnames("accordion-button", { collapsed: !collapseFilterGroup })}`} type="button" onClick={() => setCollapseFilterGroup(!collapseFilterGroup)} style={{ cursor: "pointer", borderRadius: '0px' }} >
                        {t('Button Filter')}
                    </button>
                </h2>
                <Collapse isOpen={collapseFilterGroup} className="accordion-collapse  p-3 pt-0 pt-md-3" id="collapseFilter" >
                    {children}
                </Collapse>
            </AccordionItem>
        </AccordionComponent>
    );
};

export default CollapseFilter;
